import { ClarionToaster } from '@clarion/ClarionToaster';

/** Singleton toaster instance. */
export let AppToaster = ClarionToaster;
